import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M15.257 10.989 4.906.609l13.17 7.561zM2.204 0c-.61.319-1.017.9-1.017 1.656v20.697c0 .755.408 1.336 1.017 1.655L14.24 12.002zm19.942 10.58-2.762-1.599-3.082 3.025 3.082 3.025 2.818-1.599c.845-.67.845-2.18-.056-2.851M4.906 23.404l13.17-7.56-2.82-2.819z" }, null, -1)
  ]))]))
}
export default { render: render }